/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
export default buildHelper(function (params) {
  return params[0].match(params[1]);
});
